import { F_Fammily, Font } from "../../../../util/config-fonts";
import { KEY_GENERATOR } from "../../../../functions/funtion";
import { Container } from "react-bootstrap";
import { Colors } from "../../../../util/colors";
import HorizontalSecion from "./horizontol-section";
import React from "react";

export default class ViewSection extends React.PureComponent {
  render() {
    return (
      <Container
        style={{
          overflowY: "hidden",
          paddingTop: 5,
          width: "100%",
        }}
        className="fadeInUp animated"
        data-wow-duration="300ms"
        data-wow-delay="0ms"
      >
        {/* SHOULD NOT SCROLL - Fixed header */}
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            marginTop: 5,
            marginBottom: 0,
            padding: "0px 10px",
            flexShrink: 0, // Prevent shrinking
          }}
        >
          <div
            style={{
              alignContent: "flex-start",
              textAlign: "left",
              fontSize: Font.MainHeading,
              fontFamily: F_Fammily.Medium,
              color: Colors.ThemeBGcolor,
            }}
          >
            {this.props.Name}
          </div>

          <div style={{ fontSize: 13, fontWeight: "bold", display: "none" }}>
            More
            <i className="bi bi-chevron-right" style={{ marginLeft: 10 }} />
          </div>
        </div>

        {/* SHOULD SCROLL - Horizontal scroll container */}
        <div
          style={{
            display: "flex",
            overflowY: "hidden",
            width: "100%",
            paddingBottom: 10,
          }}
        >
          {this.props.pmData.map((rs) => {
            return (
              <HorizontalSecion
                data={rs}
                key={KEY_GENERATOR()}
                navigate={this.props.navigate}
                displayFav={this.props.displayFav}
                refreshHome={this.props.refreshHome}
              />
            );
          })}
        </div>
      </Container>
    );
  }
}
